import Util from "@/Master/Util";
import {UserGlobalInfo} from "@/Core/Login/types/user";

export interface RequestOptions {
    url: string;
    type?: string; // 'GET' | 'POST' 等
    headers?: Record<string, string>;
    data?: any;
}

export interface ResponseData {
    isOk: boolean;
    data: any;
    status: number;
    err?: any;
}

export default class HttpClient {

    /**
     * 使用 Fetch API 进行流式请求
     * @param options - 请求选项
     * @param callback - 回调函数，接收响应数据
     */
    static FAjaxStream(options: RequestOptions, callback: (response: ResponseData) => void): void {
        let callResponse: ResponseData = {
            isOk: false,
            data: '',
            status: 0,
            err: '',
        };

        fetch(options.url, {
            method: options.type,
            headers: {
                ...options.headers,
            },
            body: new Uint8Array(options.data), // 替换为你的二进制数据
        })
            .then((response) => {
                callResponse.isOk = response.ok;
                callResponse.status = response.status;
                return response.json().then((data) => {
                    callResponse.data = data;
                    callback && callback(callResponse);
                }).catch((error) => {
                    callResponse.err = error;
                    callback && callback(callResponse);
                });
            })
            .catch((error) => {
                callResponse.isOk = false;
                callResponse.err = error;
                callback && callback(callResponse);
            });
    }

    /**
     * 使用 XMLHttpRequest 进行 AJAX 请求
     * @param options - 请求选项
     * @param callback - 回调函数，接收响应数据
     */
    static FAjax(options: RequestOptions, callback: (response: ResponseData) => void): void {
        const xmlHttp = new XMLHttpRequest(); // 实例化对象
        options.type = options.type ? options.type.toUpperCase() : 'GET'; // 请求类型默认是 GET

        let data: string = ''; // 初始化发送的数据

        if (options.data) {
            data = Object.entries(options.data)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
                .join('&'); // 将键值对拼接成 URL 编码的查询字符串
        }

        // 根据请求类型处理 GET 或 POST 请求
        if (options.type === 'GET') {
            if (data) {
                xmlHttp.open('GET', `${options.url}?${data}`, true);
            } else {
                xmlHttp.open('GET', `${options.url}`, true);
            }
        } else if (options.type === 'POST') {
            xmlHttp.open('POST', options.url, true);
            // 默认设置 'Content-Type'，如果用户未提供此请求头
            if (!options.headers || !options.headers['Content-Type']) {
                xmlHttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            }
        }

        // 动态设置请求头
        if (options.headers) {
            for (const [header, value] of Object.entries(options.headers)) {
                xmlHttp.setRequestHeader(header, value);
            }
        }

        xmlHttp.send(options.type === 'POST' ? data : null);

        // 处理响应
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4) {
                const response: ResponseData = {
                    isOk: xmlHttp.status === 200,
                    data: xmlHttp.responseText,
                    status: xmlHttp.status,
                };

                // 检查 responseText 是否为空以及是否为有效的 JSON 字符串
                if (response.isOk && response.data) {
                    try {
                        // 解析 JSON 前先检查内容是否是有效的 JSON
                        response.data = JSON.parse(response.data);
                    } catch (e) {
                        if (Util.isLog) {
                            // console.error("Error parsing response:", e);
                        }
                    }
                }

                callback && callback(response);
            }
        };

        xmlHttp.onerror = (e) => {
            console.error("Request failed:", e);
            callback && callback({ isOk: false, data: null, status: xmlHttp.status, err: e });
        };
    }
}
